import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  apiUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  getNotificationSettings(payload) {
    return this._http.get(
      `${this.apiUrl}/api/v1/settings/by-type?settingsType=notification_settings`,
      {
        params: payload.params,
      }
    );
  }
  getSlackChannel(payload) {
    return this._http.get(`${this.apiUrl}/api/v1/settings/slack-channels`, {
      params: payload.params,
    });
  }
  deleteSetting(payload) {
    return this._http.delete(
      `${this.apiUrl}/api/v1/settings/${payload.settingsId}`,
      {}
    );
  }

  editSetting(payload) {
    return this._http.put(
      `${this.apiUrl}/api/v1/settings/${payload.settingsId}`,
      payload.body
    );
  }
  addSetting(payload) {
    return this._http.post(`${this.apiUrl}/api/v1/settings/`, payload.body);
  }
}
